(function () {
    'use strict';

    angular.module("imApp").factory("orderProCurementService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3586,
                    parameters: parms || {}
                });
            },
            getProcurementTypeList: function () {
                return $ihttp.post({
                    method: 3592,
                    parameters: {}
                });
            },
            createOrder: function (row) {
                return $ihttp.post({
                    method: 3596,
                    parameters: row || {}
                });
            }
        };

        return service;
    }]);
})();
